var map = {
	"./icon-industry-chemical.png": "5c03",
	"./icon-industry-cluster.png": "37ed",
	"./icon-industry-device.png": "f179",
	"./icon-industry-digital.png": "d697",
	"./icon-industry-general.png": "bbc6",
	"./icon-industry-government.png": "0ee8",
	"./icon-industry-household.png": "8daa",
	"./icon-industry-logistics.png": "3b9b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a7a2";